// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ftugz{max-width:1248px;max-width:78rem;width:100%;margin:0 auto 4rem}@media(max-width:1439px){.ftugz{padding:0 2.5rem}}@media(max-width:1023px){.ftugz{padding:0 2rem}}@media(max-width:767px){.ftugz{padding:0 1.5rem;margin-bottom:2.25rem}}._2mejt{margin:3.5rem auto 2rem}@media(max-width:1439px){._2mejt{margin-top:2rem}}@media(max-width:767px){._2mejt{margin-top:1.5rem}}._28WwD{display:grid;grid-template-columns:2fr minmax(0,1fr);grid-gap:32px 24px;gap:32px 24px;grid-gap:2rem 1.5rem;gap:2rem 1.5rem;grid-template-rows:auto 1fr;grid-template-areas:\"player sidebar\" \"content sidebar\"}@media(max-width:1023px){._28WwD{grid-template-columns:minmax(0,1fr);grid-gap:1.5rem;gap:1.5rem;grid-template-areas:\"player\" \"sidebar\" \"content\"}}._2Hw8w{margin-bottom:1.5rem;font-size:32px;font-size:2rem;font-weight:500;line-height:40px;line-height:2.5rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._2Hw8w{font-size:1.625rem;line-height:2.03125rem}}._1B1bt{grid-area:player;position:relative;overflow:hidden}._1B1bt:after{content:\"\";display:block;width:100%;padding-bottom:56.25%}.M0lvS{grid-area:sidebar}._2MaAb{grid-area:content}@media(min-width:1440px){._1pHv-{width:680px}}._1pHv-:not(:last-child){border-bottom:2px solid #dcdddd}.uGAUj{margin-bottom:2rem}.qNCQu{display:none}.qNCQu._2k1L5{display:block}._1jhSF{padding:1.5rem;background-color:#fff;border-radius:.5rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;grid-gap:12px;gap:12px;grid-gap:.75rem;gap:.75rem}._1jhSF,._1H3cA{margin-bottom:1.5rem}.OKTXI{margin:1.53rem 0 .53rem}._1AQFs{padding-top:0}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "ftugz",
	"backIconRoot": "_2mejt",
	"wrapper": "_28WwD",
	"title": "_2Hw8w",
	"player": "_1B1bt",
	"sidebar": "M0lvS",
	"content": "_2MaAb",
	"tabs": "_1pHv-",
	"episodeList": "uGAUj",
	"paymentOption": "qNCQu",
	"showPaymentOption": "_2k1L5",
	"enrollPending": "_1jhSF",
	"installApp": "_1H3cA",
	"breadcrumb": "OKTXI",
	"keyPoint": "_1AQFs"
};
module.exports = exports;
